// Los cinco destellos de la Explanada. Cinco números, y están aquí por el peso.
//
// DE DÓNDE SALEN. Son la pentatónica con la que destella el tema de la Explanada —Si4, Re5,
// Mi5, La5, Si5— y **son también la voz de Alpha**: Gabri lo pidió así —*«hacer el sonido
// propio de la música para simular que está hablando»*— y la razón es buena, un balbuceo con
// notas de su casa nunca desafina.
//
// Y POR QUÉ NO VIVEN EN `ambient-temas.js`, QUE ES SU SITIO NATURAL. Porque `lib/sound.js` está
// en la **primera carga** —el sonido de la interfaz lo usa la app entera, desde la portada— y
// `sound.js` importa `vozAlpha.mjs`, que importaba la tabla de temas entera para leerle un
// array de cinco números. Eso metía los 5,6 kB de la música del mundo 3D en lo que descarga
// alguien que sólo quiere ver la portada, y el presupuesto de la primera carga está en 256,5 kB
// de 260: de los 3,5 kB que quedan, más de uno era esto.
//
// LO QUE NO SE HACE ES COPIARLOS, que es lo que parecía más fácil. La decisión escrita en
// `vozAlpha.mjs` es que **sólo hay un sitio donde está la escala**, para que el día que se
// cambie la tonalidad de la plaza Alpha cambie de voz con ella. Así que la escala no se copia:
// se muda aquí, y los dos la leen de aquí. Sigue habiendo un solo sitio; lo que cambia es que
// ese sitio pesa doce líneas y no cinco kilobytes.

/** Si4 · Re5 · Mi5 · La5 · Si5. La pentatónica de la plaza, y la voz de Alpha. */
export const DESTELLOS_DE_LA_PLAZA = [493.88, 587.33, 659.25, 880.0, 987.77];

export default DESTELLOS_DE_LA_PLAZA;
